export default class EntityManager {
    sections = {};

    addSectionManager(sectionName, manager) {
        this.sections[sectionName] = manager;
    }

    getSectionFilters(section, subsection) {
        const manager = this.getSectionManager(section);
        return manager.getFilterSchema ? manager.getFilterSchema(subsection) || [] : [];
    }

    getSectionManager(section) {
        return this.sections[section];
    }
}
